import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './sources/css/reset.css';
import App from './containers/App';
import {Provider} from "react-redux";
import store from "./store";
import zhCN from 'antd/es/locale/zh_CN';
import {ConfigProvider} from 'antd'
import axios from './request/index'

React.$axios = axios;
ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider locale={zhCN}>
            <App/>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);
